import React from "react";
import { Link } from "react-router-dom";
import { Users, Award, Zap, FileText, GraduationCap, ClipboardList, Cog, ArrowRight } from "lucide-react";

const SERVICES = [
  { icon: Users, t: "Permanent Staffing", d: "Full-time hires across all levels — from analyst to CXO. Retainer or success-based." },
  { icon: Award, t: "Executive Search", d: "CXO, VP, and Director-level searches with deep discretion and confidentiality." },
  { icon: Zap, t: "Bulk Hiring", d: "50-500+ hires for expansion, project ramp-up, or new plant openings." },
  { icon: FileText, t: "Contract Staffing", d: "Flexible workforce for time-bound projects. We manage payroll & compliance." },
  { icon: GraduationCap, t: "Campus Hiring", d: "Tier-1 and Tier-2 campus partnerships across engineering, MBA, and pharma colleges." },
  { icon: ClipboardList, t: "Payroll Support", d: "End-to-end payroll processing, PF, ESI, and statutory compliance." },
  { icon: Cog, t: "Recruitment Process Outsourcing (RPO)", d: "Embedded TA teams that scale with your growth — 3, 6, 12 months or ongoing." },
];

export default function Services() {
  return (
    <div data-testid="services-page">
      <section className="bg-[#0F2A4A] text-white py-20">
        <div className="ae-container max-w-3xl">
          <div className="ae-overline mb-4">Our Services</div>
          <h1 className="text-4xl md:text-6xl font-light">
            Full-spectrum <span className="font-serif italic text-[#C5A059]">HR solutions</span>
          </h1>
          <p className="mt-6 text-white/80 text-lg leading-relaxed">One partner. Every hiring need. From day-1 startups to Fortune 500 India offices.</p>
        </div>
      </section>

      <section className="py-24 bg-white">
        <div className="ae-container">
          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
            {SERVICES.map((s, i) => (
              <div key={i} className="ae-card p-8 group" data-testid={`service-${i}`}>
                <div className="w-14 h-14 rounded-xl bg-[#0F2A4A] group-hover:bg-[#C5A059] flex items-center justify-center mb-5 transition-colors">
                  <s.icon className="w-6 h-6 text-white" />
                </div>
                <h3 className="font-heading font-medium text-xl text-[#0F2A4A] mb-3">{s.t}</h3>
                <p className="text-sm text-slate-600 leading-relaxed">{s.d}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="py-24 bg-[#F8FAFC]">
        <div className="ae-container max-w-4xl text-center">
          <h2 className="text-3xl md:text-4xl font-medium text-[#0F2A4A]">Ready to start <span className="font-serif italic text-[#C5A059]">hiring smarter</span>?</h2>
          <p className="mt-4 text-slate-600">Tell us your requirement — we'll get back with a shortlist plan in 24 hours.</p>
          <Link to="/for-employers" className="mt-8 inline-flex ae-btn-primary" data-testid="services-cta">
            Submit Hiring Requirement <ArrowRight className="w-4 h-4 ml-2" />
          </Link>
        </div>
      </section>
    </div>
  );
}
